import React from "react";

const Benefits = () => {
  return (
    <div className="ims-benefits-wrapper">
      <h1>
        Benefits of <span>Identity</span> Mananagement Solution
      </h1>
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <p>
              Enhanced security through integrated access control and
              authentication.
            </p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <p>
              Fast and efficient production and management of identification
              credentials.
            </p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <p>
              Professional identity management solutions with customizable
              options.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
